export const privacy = {
  title: 'Privacy Policy',
  
  article1: {
    title: 'Article 1 (Information Collected)',
    item1: 'Name or nickname',
    item2: 'Email address',
    item3: 'Learning languages, language proficiency level, learning objectives',
    item4: 'Usage history, participation dates and times, session-related data (may include recordings and transcriptions)',
    item5: 'Payment information (credit card numbers and similar information are managed by payment service providers and are not retained by the Operator)'
  },
  
  article2: {
    title: 'Article 2 (Purpose of Use)',
    item1: 'Provision of the Service, matching, and operational management',
    item2: 'Communication with users, notifications, and support services',
    item3: 'Service quality improvement, analysis, and statistical processing',
    item4: 'Response to terms violations, fraudulent activities, and troubles',
    item5: 'Compliance with legal requirements or requests from administrative authorities'
  },
  
  article3: {
    title: 'Article 3 (Third-Party Provision and Outsourcing)',
    point1: 'The Operator will not provide personal information to third parties without the consent of the individual, except as required by law.',
    point2: 'However, payment processing, system operations, communications, and similar functions may be outsourced to external service providers.'
  },
  
  article4: {
    title: 'Article 4 (International Data Transfer)',
    point1: 'As the Service is provided internationally, personal information may be stored and processed in Japan and overseas (e.g., Canada).',
    point2: 'The handling of such data shall be managed in accordance with Japanese law and this Policy.'
  },
  
  article5: {
    title: 'Article 5 (Security Measures)',
    content: 'The Operator shall implement reasonable technical and organizational security measures to prevent leakage, loss, alteration, and other risks to personal information.'
  },
  
  article6: {
    title: 'Article 6 (User Rights)',
    content: 'Users may request disclosure, correction, deletion, suspension of use, and other actions regarding their personal information in accordance with applicable laws. However, requests may not be granted for information necessary for the Operator\'s legitimate business operations.'
  },
  
  article7: {
    title: 'Article 7 (Use of Cookies and Similar Technologies)',
    content: 'The Operator may use cookies and other similar technologies to improve convenience and analyze usage patterns.'
  },
  
  article8: {
    title: 'Article 8 (Retention Period)',
    content: 'Personal information shall be retained for the period necessary for the purpose of use and shall thereafter be deleted or anonymized in an appropriate manner.'
  },
  
  article9: {
    title: 'Article 9 (Policy Changes)',
    content: 'This Policy may be amended without prior notice in response to changes in laws or service content.'
  }
};
